/**
 * Created by Ding on 13/07/2017.
 */

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { Form, Input, Row, Col, Button, message, Icon } from 'antd';
import { ajaxGet } from '../../utils/ajax';

const FormItem = Form.Item;


class ResetPasswordForm extends Component {

    static propTypes = {
        form: PropTypes.object.isRequired,
    };

    state = {
        verifyCodeKey: Math.random(),
        isEmailOk: false,
        leftSeconds: 0,
        isShow: false,
        isGood: false,
    };

    onSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const params = Object.assign({}, values);
                if (params.rePassword !== params.password) {
                    message.warn('请两次输入的密码保持一致！');
                    return;
                }

                delete params.verifyCode;
                delete params.rePassword;
                this.props.handleSubmit(params, () => {
                    this.setState({
                        verifyCodeKey: Math.random(),
                    });
                });
            }
        });
    };

    onEmailChange = () => {
        setTimeout(() => {
            this.props.form.validateFieldsAndScroll(['email'], (err) => {
                if (!err) {
                    this.setState({
                        isEmailOk: true,
                        isShow: this.state.isGood,
                    });
                } else {
                    this.setState({
                        isEmailOk: false,
                        isShow: false,
                    });
                }
            });
        }, 150);
    };

    validateCode = (rule, value, callback) => {
        if (value) {
            ajaxGet('/api/hunter/verifyCode',
                { verifyCode: value },
                () => callback(),
                rawData => callback(rawData.meta.message),
            );
        } else {
            callback();
        }
    };

    validateEmailCode = (rule, value, callback) => {
        if (value) {
            ajaxGet('/api/hunter/verifyAuthCode', {
                email: this.props.form.getFieldValue('email'),
                authCode: value,
            }, () => callback(), rawData => callback(rawData.meta.message));
        } else {
            callback();
        }
    };

    validatorCheck = (value, callback) => {
        if (/\s/g.test(value)) {
            callback('密码不能含有空格');
        }
        if (/[\u4E00-\u9FFF]+/g.test(value)) {
            callback('密码不能含有汉字');
        }
        if (/(^[a-z]+$)|(^[A-Z]+$)|(^_+$)|(^\d+$)/g.test(value)) {
            callback('至少含有数字/字母/字符2种组合');
        }
        if (value.length < 9 || value.length > 12) {
            callback('密码长度为9到12位');
        }
    };

    validatePassword = (rule, value, callback) => {
        if (value) {
            this.validatorCheck(value, callback);
        }
        callback();
    };

    validateAgainPassword = (rule, value, callback) => {
        if (value) {
            this.validatorCheck(value, callback);
        }
        callback();
    };

    sendEmail = () => {
        ajaxGet('/api/hunter/sendCode', {
            email: this.props.form.getFieldValue('email'),
            verifyCode: this.props.form.getFieldValue('verifyCode'),
        }, () => {
            message.info('邮件已发送，请登录邮箱查看验证码');
            this.setState({
                leftSeconds: 90,
            });
            this.countInterval = setInterval(() => {
                if (this.state.leftSeconds > 0) {
                    this.setState({
                        leftSeconds: this.state.leftSeconds - 1,
                    });
                } else {
                    clearInterval(this.countInterval);
                }
            }, 1000);
        });
    };

    resetIpt = () => {
        const clearTime = setTimeout(() => {
            this.props.form.setFieldsValue({
                authCode: '',
                password: '',
            });
            clearTimeout(clearTime);
        }, 1200);
    };

    checkAuthCode = (event) => {
        const value = event.target.value;
        if (value.length < 4) {
            this.setState({
                isShow: false,
                isGood: false,
            });
            return;
        }

        ajaxGet('/api/hunter/verifyCode',
            { verifyCode: value },
            () => {
                this.setState({
                    isGood: true,
                });
                this.props.form.validateFieldsAndScroll(['email'], (err) => {
                    if (!err) {
                        this.setState({
                            isShow: true,
                        }, () => {
                            this.resetIpt();
                        });
                    } else {
                        this.setState({
                            isShow: false,
                        });
                    }
                });
            },
            () => {
                this.setState({
                    isGood: false,
                    isShow: false,
                });
            },
        );
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                sm: { span: 6 },
            },
            wrapperCol: {
                sm: { span: 18 },
            },
        };
        const verifiyCodeLayout = {
            labelCol: {
                sm: { span: 6 },
            },
            wrapperCol: {
                sm: { span: 8 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                sm: { span: 18, offset: 6 },
            },
        };

        return (
            <Form>
                <FormItem
                    {...formItemLayout}
                    label="邮箱"
                    hasFeedback
                >
                    {getFieldDecorator('email', {
                        rules: [
                            { type: 'email', message: '输入的邮箱格式非法' },
                            { required: true, message: '请输入您的邮箱', whitespace: true },
                        ],
                    })(
                        <Input
                            placeholder="请输入邮箱"
                            maxLength="45"
                            onChange={this.onEmailChange}
                        />,
                    )}
                </FormItem>

                <FormItem
                    {...verifiyCodeLayout}
                    label="验证码"
                    hasFeedback
                >
                    {getFieldDecorator('verifyCode', {
                        validateTrigger: 'onBlur',
                        rules: [
                            { required: true, message: '请输入验证码' },
                            { validator: this.validateCode },
                        ],
                    })(
                        <Input placeholder="请输入验证码" onChange={this.checkAuthCode} maxLength="4" />,
                    )}
                </FormItem>

                <div
                    style={{
                        position: 'absolute',
                        top: '172px',
                        right: '115px',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        this.setState({
                            verifyCodeKey: Math.random(),
                        });
                    }}
                    role="button"
                    tabIndex="0"
                >
                    <img
                        src={`/api/verifyCode.jpg?t=${this.state.verifyCodeKey}`}
                        alt="verifyCode"
                    />
                </div>

                <Icon
                    type="reload"
                    style={{
                        position: 'absolute',
                        top: '180px',
                        right: '81px',
                        fontSize: '14px',
                        color: '#fc9153',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        this.setState({
                            verifyCodeKey: Math.random(),
                        });
                    }}
                />
                {
                    this.state.isShow ?
                        <div>
                            <FormItem
                                {...verifiyCodeLayout}
                                label="邮箱验证码"
                                hasFeedback
                            >
                                {getFieldDecorator('authCode', {
                                    validateTrigger: 'onBlur',
                                    rules: [
                                        { required: true, message: '请输入邮箱验证码' },
                                        { validator: this.validateEmailCode },
                                    ],
                                })(
                                    <Input placeholder="请输入邮箱验证码" maxLength="6" />,
                                )}
                            </FormItem>

                            <Button
                                style={{
                                    position: 'absolute',
                                    top: '228px',
                                    right: '72px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    width: '133px',
                                    height: '32px',
                                }}
                                type="primary"
                                onClick={this.sendEmail}
                                disabled={!this.state.isEmailOk || this.state.leftSeconds > 0}
                            >
                                {this.state.leftSeconds > 0 ? `${this.state.leftSeconds}s` : '获取验证码'}
                            </Button>

                            <FormItem
                                {...formItemLayout}
                                label="新密码"
                                hasFeedback
                                // help="9-12位，至少含有数字/字母/字符2种组合，不能含有空格、汉字"
                            >
                                {getFieldDecorator('password', {
                                    rules: [
                                        { required: true, message: '请输入您的新密码' },
                                        { validator: this.validatePassword },
                                    ],
                                })(
                                    <Input type="password" placeholder="请输入您的新密码" minLength="9" maxLength="12" />,
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="再次输入"
                                hasFeedback
                                // help="9-12位，至少含有数字/字母/字符2种组合，不能含有空格、汉字"
                            >
                                {getFieldDecorator('rePassword', {
                                    rules: [
                                        { required: true, message: '请再次输入您的新密码' },
                                        { validator: this.validateAgainPassword },
                                    ],
                                })(
                                    <Input type="password" placeholder="请输入再次输入您的新密码" minLength="9" maxLength="12" />,
                                )}
                            </FormItem>
                            <FormItem {...tailFormItemLayout}>
                                <Button type="primary" onClick={this.onSubmit} style={{ width: '100%', fontSize: '14px' }}>
                                    修改
                                </Button>
                            </FormItem>
                        </div>
                        : ''
                }
                <FormItem {...tailFormItemLayout} style={{ marginTop: '-15px' }}>
                    <Row>
                        <Col span={12}>
                            {/* <a href="" onClick={e => e.preventDefault()}>注册</a> */}
                        </Col>
                        <Col span={12} style={{ textAlign: 'right' }}>
                            <Link to="/login">返回登录</Link>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        );
    }
}

ResetPasswordForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
};

export default Form.create({})(ResetPasswordForm);
